import { connect } from "react-redux";
import get from "lodash/get";
import { updateRoProspect } from "../../../../../../store/actions/appConfig";
import {
  getApplicationInfo,
  getRoProspect,
  getIsExistingCustomer
} from "../../../../../../store/selectors/appConfig";

import { CompanyAccountAttributesComponent } from "./CompanyAccountAttributes";

const mapDispatchToProps = {
  updateRoProspect
};

const mapStateToProps = state => ({
  prospectRiskScore: get(getApplicationInfo(state), "riskScore", ""),
  custHaveExist: get(getApplicationInfo(state), "custHaveExistCif", ""),
  roProspectRiskScore: get(getRoProspect(state), "financeInfo.riskScore", ""),
  cifNos: get(getRoProspect(state), "financeInfo.cifNo", [""]),
  isExistingCustomer: getIsExistingCustomer(state)
});

export const CompanyAccountAttributes = connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyAccountAttributesComponent);
